<script>
import moment from 'moment';
import {  BIconDownload } from 'bootstrap-vue';
import {currentRoleLevelName} from '@/mixins/roleLevelPermissions';

export default {
    props:['agreementData'],
    components:{
        BIconDownload
    },
    data(){
        return{
            partyInformation:[
                {label: 'Name:',value: this.agreementData.partner1.name.preferred},
                {label: 'Full Name:',value: `${this.agreementData.partner1.name.first || ''} ${this.agreementData.partner1.name.middle || ''} ${this.agreementData.partner1.name.last || ''}`},
                {label: 'Email:',value: this.agreementData.partner1.mail},
                {label: 'Address:',value: [this.agreementData.partner1.address.street, this.agreementData.partner1.address.city, this.agreementData.partner1.address.province]
                    .filter(Boolean)
                    .join(', ')},
                {label: 'Pronouns:',value: this.formatPronouns(this.agreementData.partner1.pronouns)},
                {label: 'Age:',value: this.calculateAge(this.agreementData.partner1.birthdate)},
                {label: 'Occupation:',value: this.agreementData.partner1.occupation},
                {label: 'Income:',value: this.formatCurrency(this.agreementData.partner1.income)}

            ],
            spouseInformation:[
                {label: 'Name:',value: this.agreementData.partner2.name.preferred},
                {label: 'Full Name:',value: `${this.agreementData.partner2.name.first || ''} ${this.agreementData.partner2.name.middle || ''} ${this.agreementData.partner2.name.last || ''}`},
                {label: 'Email:',value: this.agreementData.partner2.mail},
                {label: 'Address:',value: [this.agreementData.partner2.address.street, this.agreementData.partner2.address.city, this.agreementData.partner2.address.province]
                    .filter(Boolean)
                    .join(', ')},
                {label: 'Pronouns:',value: this.formatPronouns(this.agreementData.partner2.pronouns)},
                {label: 'Age:',value: this.calculateAge(this.agreementData.partner2.birthdate)},
                {label: 'Occupation:',value: this.agreementData.partner2.occupation},
                {label: 'Income:',value: this.formatCurrency(this.agreementData.partner2.income)}

            ],
            childrenInformation: this.agreementData.children.map((child)=>{
                return {
                    firstName: child.name.first,
                    middleName: child.name.middle,
                    lastName: child.name.last,
                    preferredName: child.name.preferred,
                    pronoun : this.formatPronouns(child.pronouns),
                    birthday: this.formatDate(child.birthdate),
                    age: this.calculateAge(child.birthdate)
                }
            }),
            showLearnButton: ['client-level-1', 'client-level-2'].includes(currentRoleLevelName)
        }
    },
    methods:{
        calculateAge(birthdate){
            if(birthdate){
                const birthMoment = moment(birthdate);
                const currentMoment = moment();
                const years = currentMoment.diff(birthMoment, 'years');
                const months = currentMoment.diff(birthMoment, 'months');

                if (years >= 1) {
                    return years + ' year(s)';
                } else {
                    return months + ' month(s)';
                }
            }
            return ''

        },
        calculateRelationshipDuration(startDate, endDate) {
            if (startDate && endDate) {
                const start = moment(startDate);
                const end = moment(endDate);
                const years = end.diff(start, 'years');
                const months = end.diff(start, 'months');

                if (years >= 1) {
                    return years + ' year(s)';
                } else {
                    return months + ' month(s)';
                }
            }
            
            return '';
        },
        formatDate(date){
            if(date){
               return moment(date).format('MMMM Do YYYY')
            }
            return ''
        },

        removeBanners() {
            const banners = document.querySelectorAll(
                '.userflowjs-banner-root, .userflowjs-theme-root, [class*="userflow"]'
            );
            
            if (banners.length > 0) {
                banners.forEach(banner => {
                if (banner && banner.parentNode) {
                    banner.parentNode.removeChild(banner);
                }
                });
            }
        },
        // downloadFactSheet(){
        //     const { partner1, partner2 } = this.agreementData;
        //     const partner1Last = (partner1 && partner1.name.last) || '';
        //     const partner2Last = (partner2 && partner2.name.last) || '';
        //     document.title = partner1Last == partner2Last ? `${partner1Last} Separation Fact Sheet` : `${partner1Last} ${partner2Last} Separation Fact Sheet`;
        //     setTimeout(() => {
        //         window.print();
        //     }, 100);
        // },
        downloadFactSheet() {
            const { partner1, partner2 } = this.agreementData;
            const partner1Last = (partner1?.name?.last) || '';
            const partner2Last = (partner2?.name?.last) || '';
            const documentTitle = partner1Last === partner2Last 
                ? `${partner1Last} Separation Fact Sheet` 
                : `${partner1Last} ${partner2Last} Separation Fact Sheet`;
            document.title = documentTitle;
            const printWithA4Styles = (printFn) => {
                const styleElement = document.createElement('style');
                styleElement.id = 'print-a4-styles';
                styleElement.textContent = `
                    @page {
                        size: A4 portrait !important;
                        orphans: 0 !important;
                        widows: 0 !important;
                    }
                `;
                document.head.appendChild(styleElement);

                printFn();

                setTimeout(() => {
                    const addedStyle = document.getElementById('print-a4-styles');
                    if (addedStyle && addedStyle.parentNode) {
                        addedStyle.parentNode.removeChild(addedStyle);
                    }
                }, 1000);
            };

            setTimeout(() => {
                const userAgent = navigator.userAgent;
                const isIOS = /iPad|iPhone|iPod/.test(userAgent);
                const isIOSChrome = /CriOS/i.test(userAgent) && isIOS;
                const isSafari = /^((?!chrome|android|crios).)*safari/i.test(userAgent);
                const isIPhoneSafari = isIOS && isSafari;

                const isMac = /Mac/.test(userAgent);
                const isChrome = /Chrome/.test(userAgent);
                const isMacChromeSafari = isMac && (isChrome || isSafari);
                const isEdge = /Edg/.test(userAgent);
                try {
                    const content = document.querySelector('.separation-fact-sheet');
                    if (!content) {
                        throw new Error('Separation fact sheet content not found');
                    }
                    const contentClone = content.cloneNode(true);
                    const downloadBtn = contentClone.querySelector('.print-hide');

                    if (downloadBtn && downloadBtn.parentNode) {
                        downloadBtn.parentNode.removeChild(downloadBtn);
                    }

                    const logo = contentClone.querySelector('.divii-logo img');
                    if (logo) {
                        logo.style.visibility = 'visible';
                        logo.style.display = 'block';

                        const img = new Image();
                        img.src = logo.src;
                        img.onload = function() {
                            const canvas = document.createElement('canvas');
                            canvas.width = img.width;
                            canvas.height = img.height;
                            const ctx = canvas.getContext('2d');
                            ctx.drawImage(img, 0, 0);
                            try {
                                logo.src = canvas.toDataURL('image/png');
                            } catch (e) {
                                console.error('Could not convert logo to data URL', e);
                            }
                        };
                    }

                    const printDoc = `
                    <!DOCTYPE html>
                    <html>
                    <head>
                        <title>${documentTitle}</title>
                        <meta name="viewport" content="width=device-width, initial-scale=1.0">
                        <style>
                            @page {
                                size: A4;
                                margin: 10mm;
                                orphans: 0;
                                widows: 0;
                            }

                            html, body {
                                height: 100%;
                                overflow: hidden;
                                width: 100% !important;
                                margin: 0 !important;
                                padding: 0 !important;
                                -webkit-text-size-adjust: 100% !important;
                                line-height: 1.2 !important;
                                color: #333 !important;
                            }

                            body {
                                font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
                                box-sizing: border-box;
                                max-width: 190mm !important;
                                margin: 0 auto !important;
                            }
                            
                            /* Layout fixes */
                            .d-flex {
                                display: flex !important;
                            }
                            
                            .justify-content-between {
                                justify-content: space-between !important;
                            }
                            
                            .flex-wrap {
                                flex-wrap: wrap !important;
                            }
                            
                            .info-table-container {
                                display: flex;
                                margin-bottom: 26px !important;
                                width: 100%;
                            }
                            
                            .info-table {
                                width: 49% !important;
                                margin: 0 !important;
                                border-collapse: collapse !important;
                            }
                            
                            .info-table:first-child {
                                margin-right: 2% !important;
                            }
                            
                            .mb-table {
                                margin-bottom: 16px !important;
                            }
                            
                            /* Table styles */
                            table {
                                border-collapse: collapse !important;
                                width: 100% !important;
                                border: 1px solid #dee2e6 !important;
                                page-break-inside: avoid !important;
                            }
                            
                            th, td {
                                padding: 3px !important;
                                border: 1px solid #dee2e6 !important;
                                text-align: left;
                                vertical-align: top;
                                font-size: 0.85rem;
                            }
                            
                            th {
                                font-weight: bold;
                            }
                            
                            .fact-sheet-heading {
                                background-color: #3F6772 !important;
                                color: white !important;
                            }
                            
                            .row-bg-white {
                                background-color: #ffffff !important;
                            }
                            
                            .divii-logo {
                                display: block !important;
                            }
                            
                            .divii-logo img {
                                display: block !important;
                                visibility: visible !important;
                                width: 100px !important;
                                height: auto !important;
                            }
                            
                            .page-heading {
                                color: #3F6772 !important;
                                font-weight: 700 !important;
                                font-size: 1.1rem !important;
                                margin-bottom: 0;
                            }
                            
                            hr {
                                border: 0;
                                border-top: 1px solid black;
                                margin: 0.5rem 0 1rem 0;
                            }
                            
                            .separation-fact-sheet {
                                page-break-after: avoid !important;
                                page-break-inside: avoid !important;
                                break-inside: avoid !important;
                                margin: 0 !important;
                                padding: 0 !important;
                                height: auto !important;
                                overflow: hidden !important;
                            }

                            * {
                                page-break-after: avoid !important;
                                page-break-inside: avoid !important;
                                break-inside: avoid !important;
                            }
                            /* Print-specific styles */
                            @media print {
                                html, body { 
                                    height: auto !important;
                                    -webkit-print-color-adjust: exact !important;
                                    color-adjust: exact !important;
                                    print-color-adjust: exact !important;
                                    width: 100%;
                                    margin: 0 !important;
                                    padding: 0 !important;
                                    overflow: visible !important;
                                }

                                .userflowjs-theme-root {
                                    display: none !important;
                                    padding: 0px !important;
                                    margin: 0px !important;
                                }

                                .font-weight-bold {
                                    font-weight: bold !important;
                                }

                                .print-hide, .section-heading {
                                    display: none !important;
                                }
                                
                                .card {
                                    border: none !important;
                                    padding: 0 !important;
                                    margin: 0 !important;
                                    box-shadow: none !important;
                                }

                                .card-body {
                                    padding: 0 !important;
                                    margin: 0 !important;
                                }
                                
                                .fact-sheet-heading {
                                    background-color: #3F6772 !important;
                                    color: white !important;
                                    -webkit-print-color-adjust: exact !important;
                                    print-color-adjust: exact !important;
                                }
                            }
                        </style>
                    </head>
                    <body>
                        ${contentClone.outerHTML}
                    </body>
                    </html>
                    `;
                    if (isIPhoneSafari) {
                        console.log('iPhone Safari printing...');
                        this.removeBanners();
                        printWithA4Styles(() => document.execCommand('print'));
                    } 
                    else if (isIOSChrome) {
                        console.log('Chrome printing...');
                        this.removeBanners();
                        printWithA4Styles(() => {
                            try {
                                if (typeof window.print === 'function') {
                                    window.print();
                                } else if (typeof document.execCommand === 'function') {
                                    document.execCommand('print');
                                }
                            } catch (error) {
                                console.warn('iPhone Chrome printing failed:', error);
                            }
                        });
                    }
                    else if (isMacChromeSafari || isEdge) {
                        console.log('Mac Chrome/Safari/Edge printing...');
                        const blob = new Blob([printDoc], { type: 'text/html' });
                        const blobUrl = URL.createObjectURL(blob);

                        const printFrame = document.createElement('iframe');
                        printFrame.style.position = 'fixed';
                        printFrame.style.right = '0';
                        printFrame.style.bottom = '0';
                        printFrame.style.width = '0';
                        printFrame.style.height = '0';
                        printFrame.style.border = '0';
                        document.body.appendChild(printFrame);

                        printFrame.src = blobUrl;
                        
                        printFrame.onload = () => {
                            try {
                                // Attempt to force image to load in the iframe
                                const iframeDoc = printFrame.contentDocument || printFrame.contentWindow.document;
                                const logoImg = iframeDoc.querySelector('.divii-logo img');
                                if (logoImg) {
                                    // Try to load the image directly in the iframe
                                    const imgSrc = logoImg.getAttribute('src');
                                    if (imgSrc && imgSrc.indexOf('data:') === -1) {
                                        const absoluteImgPath = new URL(imgSrc, window.location.href).href;
                                        logoImg.setAttribute('src', absoluteImgPath);
                                    }
                                }

                                const bodyElement = iframeDoc.body;
                                if (bodyElement) {
                                    bodyElement.style.margin = '0';
                                    bodyElement.style.padding = '0';
                                    bodyElement.style.maxHeight = 'none';
                                    bodyElement.style.overflow = 'visible';
                                }

                                const styleElement = document.createElement('style');
                                styleElement.textContent = `
                                    @page {
                                        size: A4 portrait !important;
                                        margin: 10mm !important;
                                        orphans: 0 !important;
                                        widows: 0 !important;
                                    }
                                    @media print {
                                        body { 
                                            height: auto !important; 
                                            max-height: none !important; 
                                            overflow: hidden !important; 
                                            padding: 0 !important;
                                            margin: 0 !important;
                                        }
                                        html { 
                                            height: auto !important; 
                                            max-height: none !important;
                                            overflow: hidden !important;
                                        }
                                        .separation-fact-sheet {
                                            page-break-after: avoid !important;
                                            break-after: avoid !important;
                                            overflow: hidden !important;
                                            max-height: none !important;
                                        }
                                        .page-heading {
                                            margin-top: 0.5rem !important;
                                        }
                                        table {
                                            page-break-inside: avoid !important;
                                        }
                                        th, td {
                                            padding: 0.44rem !important;
                                            font-size: 0.75rem !important;
                                        }
                                    }
                                `;
                                iframeDoc.head.appendChild(styleElement);
                                
                                printFrame.contentWindow.focus();
                                
                                setTimeout(() => {
                                    printFrame.contentWindow.document.title = documentTitle;
                                    printFrame.contentWindow.print();
                                    
                                    setTimeout(() => {
                                        URL.revokeObjectURL(blobUrl);
                                        document.body.removeChild(printFrame);
                                    }, 1000);
                                }, 500); // Increased timeout to ensure image loads
                            } catch (e) {
                                console.error('Print failed:', e);
                                window.print();
                            }
                        };
                }else {
                    console.log('Default printing...');
                    this.removeBanners();
                    window.print();
                }
                } catch (error) {
                    console.error('Fact sheet download failed due to hidden issue', error);
                    window.print();
                }
            }, 100);
        },
        formatPronouns(gender){
            if(gender === 'male'){
                return 'He/Him/His'
            }
            else if(gender === 'female'){
                return 'She/Her/Hers'
            }
            else if(gender === 'neutral'){
                return 'They/Them/Their'
            }
            else{
                return ''
            }
        },
        formatCurrency(value ) {
            if(!value && value !== 0){
                return
            }
            value = parseFloat(value).toFixed(2);
            return new Intl.NumberFormat("en-US", {
                minimumFractionDigits: 2,
                style: "currency",
                currency: "USD"
            }).format(value);
        },
        relationshipStatusLabel(){
            const {cohabited, married} = this.agreementData.relationship;
            if(married && cohabited){
                return 'Married'
            }
            if(married){
                return 'Married, never cohabited'
            }
            if(cohabited){
                return 'Cohabited, not married'
            }
            if(cohabited === false){
                return 'Never cohabited'
            }
            return ''
        },
        relationshipInformation(){
            const relationship = this.agreementData.relationship;
            const statusRow = {label: 'Relationship Status:', value: this.relationshipStatusLabel};
            // Nothing to date if they neither cohabited nor married.
            if(!relationship.cohabited && !relationship.married){
                return [statusRow]
            }
            return [
                statusRow,
                {label: 'Length of Relationship:',value:this.calculateRelationshipDuration(relationship.cohabitationDate, relationship.separationDate)},
                {label: 'Cohabitation Date:', value: this.formatDate(relationship.cohabitationDate)},
                {label: 'Marriage Date (if married):', value: relationship.married ? this.formatDate(relationship.marriageDate): ''},
                {label: 'Separation Date:',value: this.formatDate(relationship.separationDate)},
            ]
        }
    },
    mounted(){
        window.addEventListener('afterprint', function () {
			setTimeout(() => {
				document.title = 'Divii';
			}, 100);
		});
    }

}
</script>

<template>
    <b-card class="separation-fact-sheet">
        <div slot="header" class="section-heading">
            <h4>Separation Fact Sheet</h4>
            <a href="#" onclick="Intercom('showArticle', 11203361)" v-if="this.showLearnButton">Learn &nbsp;<b-icon-book/></a>
        </div>
        <b-button @click="downloadFactSheet" class="d-flex ml-auto mb-3 btn-primary print-hide align-items-center"><b-icon-download></b-icon-download>&nbsp; Download</b-button>
        
        <div class="d-flex justify-content-between align-items-start">
            <div>
                <div class="page-heading">SEPARATION FACT SHEET</div>
                <div>({{ agreementData.partner1.name.last }} - {{ agreementData.partner2.name.last }})</div>
            </div>
                
            <div class="divii-logo">
                <img src="@/assets/Divii-Logo-Primary.svg" alt="divii logo" width="100" />
            </div>
        </div>
        <hr class="fact-sheet-hr">
        
        <!-- Using table layout instead of flexbox for better alignment -->
        <div class="info-table-container">
            <table class="info-table">
                <thead>
                    <tr>
                        <th colspan="2" class="font-weight-bold fact-sheet-heading">Party Information</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in partyInformation" :key="item.id" class="row-bg-white">
                        <td class="text-left font-weight-bold">{{ item.label }}</td>
                        <td>{{ item.value }}</td>
                    </tr>
                </tbody>
            </table>

            <table class="info-table">
                <thead>
                    <tr>
                        <th colspan="2" class="font-weight-bold fact-sheet-heading">Spouse Information</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in spouseInformation" :key="item.id" class="row-bg-white">
                        <td class="text-left font-weight-bold">{{ item.label }}</td>
                        <td>{{ item.value }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <table class="mb-table">
            <thead>
                <tr>
                    <th colspan="2" class="font-weight-bold fact-sheet-heading">Relationship Information</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in relationshipInformation()" :key="item.id" class="row-bg-white">
                    <td class="text-left font-weight-bold">{{ item.label }}</td>
                    <td>{{ item.value }}</td>
                </tr>
            </tbody>
        </table>

        <table class="mb-table" v-if="agreementData.children.length > 0">
            <b-thead>
                <b-tr>
                    <th colspan="7" class="font-weight-bold fact-sheet-heading">Children Information</th>
                </b-tr>
                <b-tr class="font-weight-bold">
                    <td>Full Name</td>
                    <td v-if="childrenInformation.some(child =>child.preferredName)">Preferred Name</td>
                    <td>Pronouns</td>
                    <td>Birthday</td>
                    <td>Age</td>
                </b-tr>
            </b-thead>
            <b-tbody>
                <b-tr v-for="item in childrenInformation" :key="item.id" class="row-bg-white">
                    <td>
                        {{ (item.firstName || '') + ' ' + (item.middleName || '') + ' ' + (item.lastName || '') }}
                    </td>
                    <td v-if="childrenInformation.some(child =>child.preferredName)">
                        {{ item.preferredName }}
                    </td>
                    <td>
                        {{ item.pronoun }}
                    </td>
                    <td>
                        {{ item.birthday }}
                    </td>
                    <td>
                        {{ item.age }}
                    </td>
                </b-tr>
            </b-tbody>
        </table>

        <table class="mb-table" v-if="agreementData.agreement.sections.length > 0">
            <thead>
                <tr>
                    <th colspan="4" class="font-weight-bold fact-sheet-heading">Issues</th>
                </tr>
            </thead>
            <tbody>
                <tr class="row-bg-white">
                    <td v-for="(item, index) in agreementData.agreement.sections" :key="index">
                        <template v-if="item === 'Property'">
                            Property Distribution
                        </template>
                        <template v-else>
                            {{ item }}
                        </template>
                    </td>
                </tr>
            </tbody>
        </table>
    </b-card>
</template>

<style scoped>
.page-heading {
    color: #3F6772;
    font-weight: 700;
    font-size: 1.3rem;
}

.fact-sheet-heading {
    background-color: #3F6772 !important;
    color: white !important;
}

.row-bg-white {
    background-color: #ffff !important;
}

.fact-sheet-hr {
    border-top: 1px solid black !important;
    margin-bottom: 1.5rem;
}

/* Image styling */
.divii-logo {
    display: block;
}

.divii-logo img {
    display: block !important;
    visibility: visible !important;
    width: 100px;
    height: auto;
}

/* Table layout using baseline CSS */
.info-table-container {
    display: flex;
    justify-content: space-between;
    margin-bottom: 34px;
    width: 100%;
}

.info-table {
    width: 49%;
    border-collapse: collapse;
}

.info-table:first-child {
    margin-right: 2%;
}

.mb-table {
    margin-bottom: 30px;
    width: 100%;
    border-collapse: collapse;
}

table {
    border: 1px solid #dee2e6;
}

th, td {
    padding: 0.55rem;
    border: 1px solid #dee2e6;
    text-align: left;
    vertical-align: top;
}

@page {
    size: A4 portrait !important;
}
@media print {
    .print-hide {
        display: none !important;
    }
    
    .separation-fact-sheet .card-header {
        display: none !important;
        page-break-inside: avoid !important;
    }

    .userflowjs-theme-root,
    .userflowjs-banner-root {
        display: none !important;
        padding: 0px !important;
        margin: 0px !important;
    }
    
    .separation-fact-sheet.card {
        border: none !important;
        page-break-inside: avoid !important;
    }
    
    table .fact-sheet-heading {
        background-color: #3F6772 !important;
        color: white !important;
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
    }

    /* Force table layout in print */
    .info-table-container {
        display: flex !important;
        justify-content: space-between !important;
        width: 100% !important;
        margin-bottom: 34px !important;
    }
    
    .info-table {
        width: 49% !important;
    }
    
    .info-table:first-child {
        margin-right: 2% !important;
    }
    
    .mb-table {
        margin-bottom: 30px !important;
    }
    
    /*NB:  Force image visibility in print for safari */
    .divii-logo {
        display: block !important;
        visibility: visible !important;
    }
    
    .divii-logo img {
        display: block !important;
        visibility: visible !important;
        width: 100px !important;
        height: auto !important;
    }

    /* NB: Force Single page print only for safari */
    html, body {
        height: auto !important;
        overflow: hidden !important;
        page-break-inside: avoid !important;
    }
    
    * {
        page-break-after: avoid !important;
        page-break-inside: avoid !important;
        break-inside: avoid !important;
    }
}
</style>